<script setup lang="ts">
import {
  DropdownMenuRoot,
  DropdownMenuTrigger,
  DropdownMenuPortal,
  DropdownMenuContent,
} from 'reka-ui';
import { cn } from '@/lib/cn';

const props = defineProps<{
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'bottom' | 'left' | 'right';
  class?: string;
}>();
</script>

<template>
  <DropdownMenuRoot>
    <DropdownMenuTrigger as-child>
      <slot name="trigger" />
    </DropdownMenuTrigger>
    <DropdownMenuPortal>
      <DropdownMenuContent
        :align="props.align ?? 'end'"
        :side="props.side ?? 'bottom'"
        :side-offset="6"
        :class="cn(
          'z-50 min-w-[200px] rounded-xl border border-border bg-surface p-1 shadow-pop',
          'data-[state=open]:animate-slide-in-up outline-none',
          props.class,
        )"
      >
        <slot />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>
